import { render, staticRenderFns } from "./ChoferPivotTable.vue?vue&type=template&id=5cfa83fc"
import script from "./ChoferPivotTable.vue?vue&type=script&lang=js"
export * from "./ChoferPivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports